import React, { useState } from 'react';
import '../../../styles/iqac/main.css';
import { Link } from 'react-router-dom';

const Main = () => {

    const [activeTab, setActiveTab] = useState('signup_form12');

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };


    return (
        <div id='IqacMain'>
            <div className="iqac-main">
                <div className="container mt-5">
                    <div className="row rounded-1">
                        {/* <div className="col-md-8 offset-md-2 mt-5 fancy-forms"> */}
                        {/* <div className="cardbox"> */}
                        <ul className="nav nav-tabs  mt-3" id="myTab" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form')}
                                >
                                    IQAC
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form1' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form1')}
                                >
                                    AQAR Reports
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form2' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form2')}
                                >
                                    Minutes of IQAC meetings
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form3' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form3')}
                                >
                                    Best Practices
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form4' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form4')}
                                >
                                    IQAC Committee Letter
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form5' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form5')}
                                >
                                    Notifications
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form6' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form6')}
                                >
                                    Institutional Distinctiveness
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form7' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form7')}
                                >
                                    Industry Consultancy Cell
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form8' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form8')}
                                >
                                    Facilities
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form9' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form9')}
                                >
                                    Proceeding AC/BOS
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form10' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form10')}
                                >
                                    Student Projects/ Field Reports
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form11' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form11')}
                                >
                                    Academic Calendar
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form12' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form12')}
                                >
                                    Audited Statement of Income Expenditure
                                </button>
                            </li>
                            {/* <li className="nav-item">
              <a className="nav-link" id="signup" data-toggle="tab" href="#signup_form13" role="tab"
                  aria-controls="signup" aria-selected="false">Revised Final Report of the Screening Committee</a>
          </li> */}
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form13' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form13')}
                                >
                                    Feedback
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form14' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form14')}
                                >
                                    Activities
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'signup_form15' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('signup_form15')}
                                >
                                    Contact
                                </button>
                            </li>
                        </ul>



                        <div className="tab-content" id="myTabContent">



                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form' ? 'show active' : ''}`} id="signup_form"
                            >
                                <div className="IAQAC mt-4">
                                    <div className="container">
                                        <h1
                                            className="my-heading"
                                            style={{ fontSize: 24, paddingLeft: 50 }}
                                        >
                                            Internal quality Assurance Cell (IQAC)
                                        </h1>
                                        <div className="main-box mt-3 d-flex">
                                            <div className="col-lg-3 col-sm-12 links">
                                                <div className="top-heading">
                                                    <h2>Important Links</h2>
                                                </div>
                                                <div className="bottom">
                                                    <Link to="/iqac">IQAC</Link>
                                                    <Link to="/iqac-aqar-report">AQAR Reports</Link>
                                                    <Link to="/iqac-meet">Minutes of meetings</Link>
                                                    <Link to="/iqac-practices">Best Practices</Link>
                                                    <Link to="/iqac-letter">Committee Letter</Link>
                                                    <Link to="/iqac-notifications">Notifications</Link>
                                                    <Link to="/distinctiveness">
                                                        Institutional Distinctiveness
                                                    </Link>
                                                    <Link to="/industry-consultancy-cell">
                                                        Industry Consultancy Cell
                                                    </Link>
                                                    <Link to="/facilities">Facilities</Link>
                                                    <Link to="/proceeding-ac-bos">Proceeding AC/BOS</Link>
                                                    <Link to="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/iqac/student_projects.pdf">
                                                        Student Projects/ Field Reports
                                                    </Link>
                                                    <Link to="/academic-calendar">Academic Calendar</Link>
                                                    <Link to="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/pdf-files/Budget-2015-21.pdf">
                                                        Audited Statement of Income Expenditure
                                                    </Link>
                                                    <Link to="/iqac-feedback">Feedback</Link>
                                                    <Link to="/iqac-activities">Activities</Link>
                                                    <Link to="/iqac-contact">Contact</Link>
                                                    <Link
                                                        to="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/10/Student%20Satisfaction%20Survey%20Form%20and%20Report%20(1).pdf"
                                                        target="_blank"
                                                    >
                                                        Students Satisfaction Survey Report 2022-23
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="col-lg-9 col-sm-12 links">
                                                <div className="top-heading">
                                                    <h2>IQAC</h2>
                                                </div>
                                                <div className="content">
                                                    <div className="top">
                                                        <div className="box">
                                                            <img src="../assets/images/iqac/owner3.jpg" alt="" />
                                                            <h1>Prof. Sangeeta Shukla</h1>
                                                            <p>Chairperson</p>
                                                        </div>
                                                        <div className="box">
                                                            <img src="../assets/images/iqac/ncg-ad.jpg" alt="" />
                                                            <h1>Prof. N.C. Gautam</h1>
                                                            <p>Advisor</p>
                                                        </div>
                                                        <div className="box">
                                                        <img src="../assets/images/iqac/iqac-pic-1.jpg"
                                                                    alt=""
                                                                />
                                                            <h1>Prof. Hare Krishna</h1>
                                                            <p>Coordinator</p>
                                                        </div>
                                                    </div>
                                                    <div className="middle">
                                                        <h1>The Team</h1>
                                                    </div>
                                                    <div className="down">
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/rag.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Dr. Rajendra Kumar Agrawal (Member)</h1>
                                                                <p>Ex Member of Parliament</p>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-1.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Prof. Hare Krishna (Member)</h1>
                                                                <p>Department of Statistics</p>
                                                                <span>Mobile : 0121-2603964</span>
                                                                <span>Email : hkrishnastats@yahoo.com</span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-2.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Prof. Navin Chandra Lohani (Member)</h1>
                                                                <p>Department of Hindi</p>
                                                                <span>Mobile : 9412207200</span>
                                                                <span>Email : nclohani@gmail.com</span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-3.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Prof. Jaimala (Member)</h1>
                                                                <p>Department of Mathematics</p>
                                                                <span>Mobile : 9837991844</span>
                                                                <span>Email : jaimalaccsu@gmail.com</span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-4.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Prof. Bhupendra Singh (Member)</h1>
                                                                <p>Department of Statistics</p>
                                                                <span>Mobile : 9760484706</span>
                                                                <span>Email : bhupendra.rana@gmail.com</span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-5.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Prof. Bindu Sharma (Member)</h1>
                                                                <p>Department of Zoology</p>
                                                                <span>Mobile : 7983339533</span>
                                                                <span>
                                                                    Email : dr.bindusharmazoology@gmail.com
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-6.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Prof. Anuj Kumar (Member)</h1>
                                                                <p>Department of Physics</p>
                                                                <span>Mobile : 9131025706</span>
                                                                <span>Email : dranujkumarccsu@gmail.com</span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-7.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Prof. Ravindra Sharma (Member)</h1>
                                                                <p>Department of Economics</p>
                                                                <span>Mobile : 9424358256</span>
                                                                <span>Email : ravendra_s@yahoo.com</span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-8.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Prof. Dr. Jitender Singh</h1>
                                                                <p>Department of Microbiology</p>
                                                                <span>Mobile : 7017785669</span>
                                                                <span>Email : jeets80@gmail.com</span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-9.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Dr. Sachin Kumar (Member)</h1>
                                                                <p>
                                                                    Department of Genetics &amp; Plant Breeding
                                                                </p>
                                                                <span>Mobile : 7060504035</span>
                                                                <span>Email : sachinkpsingh@gmail.com</span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-10.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Dr. Ram Kumar Gupta (Member)</h1>
                                                                <p>Industrialist</p>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-12.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Shri. Satya Prakash (Member)</h1>
                                                                <p>Dy. Registrar (Examination)</p>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-13.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Shri. Amit Singh Nayal (Member)</h1>
                                                                <p>Department of Statistics</p>
                                                                <span>Mobile : 8171924864</span>
                                                                <span>Email : amitnayal009@gmail.com</span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/iqac-pic-14.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Km. Shehreen (Member)</h1>
                                                                <p>Department of Economics Student</p>
                                                                <span className="mt-2">Student</span>
                                                            </div>
                                                        </div>
                                                        <div className="boxing">
                                                            <div className="left">
                                                                <img
                                                                    src="../assets/images/iqac/marika_jayant.jpg"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="right">
                                                                <h1>Ms. Merika Jayant</h1>
                                                                <p>Department of Zoology</p>
                                                                <span className="mt-2">Student</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form1' ? 'show active' : ''}`} id="signup_form1"
                            >
                                 <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Annual Quality Assurance Report (AQAR) of the IQAC 2022-23</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/01/aqar-2022-23.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Annual Quality Assurance Report (AQAR) of the IQAC 2015-16</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/AQAR_2015_16.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Annual Quality Assurance Report (AQAR) of the IQAC 2016-17</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/AQAR_2016-2017_updated.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Annual Quality Assurance Report (AQAR) of the IQAC 2017-18</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/AQAR_2017-2018_updated.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Annual Quality Assurance Report (AQAR) of the IQAC 2018-19</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/AQAR_2018-2019_updated.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Annual Quality Assurance Report (AQAR) of the IQAC 2019-20</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/AQAR_2019-2020_updated.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Annual Quality Assurance Report (AQAR) of the IQAC 2020-21</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/AQAR-2020-2021_updated.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Annual Quality Assurance Report (AQAR) of the IQAC 2021-22</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/iqac/AQAR-2021-22.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form2' ? 'show active' : ''}`} id="signup_form2"
                            >
                                 <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>IQAC Meeting 2023-24</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/12/Minutes%20of%202023-24_30122024171255.PDF"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2015-16</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/iqac/IQAC_Meetings_2015_16.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2016-17</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/iqac/IQAC_Meetings_2016_17.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2017-18</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/iqac/IQAC_Meetings_2017_18.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2018-19</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/iqac/IQAC_Meetings_2018_19.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2019-20</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/iqac/IQAC_Meetings_2019_20.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2020-21</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/iqac/IQAC_Meetings_2020_21.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2021-22</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/iqac/IQAC_Meetings_2021_22.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2022-23</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/10/Iqac%20meetings%20proceeding_22102024165125.PDF"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form3' ? 'show active' : ''}`} id="signup_form3"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Best Practices 2015-16</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/Best_Practices_2015_16.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Best Practices 2016-17</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/Best_Practices_2016_17.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Best Practices 2017-18</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/Best_Practices_2017_18.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Best Practices 2018-19</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/Best_Practices_2018_19.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Best Practices 2019-20</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/Best_Practices_2019_20.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Best Practices 2020-21</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/Best_Practices_2020_21.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Best Practices 2021-22</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/Best_Practices_2021_22.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form4' ? 'show active' : ''}`} id="signup_form4"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>IQAC Committee Letter 2021-22</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/10/5809.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Committee Letter 2015-16</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/IQAC_Committee_Letter_2015_16.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Committee Letter 2016-17</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/IQAC_Committee_Letter_2016-17.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Committee Letter 2017-18</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/IQAC_Committee_Letter_2017_18.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Committee Letter 2018-19</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/IQAC_Committee_Letter_2018-19_2019-20_and_2020-21.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Committee Letter 2019-20</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/IQAC_Committee_Letter_2018-19_2019-20_and_2020-21.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Committee Letter 2020-21</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/iqac/IQAC_Committee_Letter_2018-19_2019-20_and_2020-21.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC committee letter 2022-23</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/10/5809.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form5' ? 'show active' : ''}`} id="signup_form5"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Posted Date</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                Revised Report of Screening Committee of Assistant Professor
                                                (OBC-01) Dept. of Genetics &amp; Plant Breeding
                                            </td>
                                            <td>15-06-2022</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/acad-2647.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Principal- All Colleges/ Institutes (Regarding IQAC workshop
                                                on different Subjects)
                                            </td>
                                            <td>19-11-2021</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2021-11-19_2347.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Report of Screening Committee for the post of Associate
                                                Professor (OBC) in the Department of Statistics
                                            </td>
                                            <td>09-10-2021</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2021-10-09_2237.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Report of Screening Committee for the post of Professor (SC)
                                                in the Department of Mathematics
                                            </td>
                                            <td>09-10-2021</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2021-10-09_2236.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2020-21</td>
                                            <td>24-06-2021</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2021-08-29_2152.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Regarding: Kaashyipi (The biannual journal of IQAC, Ch. Charan
                                                Singh University, Meerut)
                                            </td>
                                            <td>14-08-2020</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2020-08-14_1144.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Related to Webinar on NAAC Awareness on 29 June, 2020 at 11.00
                                                AM
                                            </td>
                                            <td>18-06-2020</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2020-06-18_1034.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Principal / Coordinator I.Q.A.C.- All Colleges / Institutions
                                                (workshop on Awareness of NAAC on 10 Jan 2020)
                                            </td>
                                            <td>06-01-2020</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2020-01-06_744.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2018-19</td>
                                            <td>24-10-2019</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2021-08-29_2151.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2017-18</td>
                                            <td>18-01-2018</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2021-08-29_2150.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Committee Letter 2016-17</td>
                                            <td>09-08-2017</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2021-08-29_2147.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2016-17</td>
                                            <td>17-06-2017</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2021-08-29_2148.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Meetings 2015-16</td>
                                            <td>15-06-2016</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2021-08-29_2146.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>IQAC Committee Letter 2015-16</td>
                                            <td>11-05-2016</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2021-08-29_2145.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form6' ? 'show active' : ''}`} id="signup_form6"
                            >
                                <h4>7.3.1</h4>
                                <p>
                                    PORTRAY THE PERFORMANCE OF THE INSTITUTION IN ONE AREA DISTINCTIVE
                                    TO ITS PRIORITY AND THRUST (within 1000 words)
                                </p>
                                <p>
                                    <strong>
                                        Revealing the untold chapters of the Indian Freedom Struggle
                                    </strong>
                                </p>
                                <p>
                                    The CCS University, Meerut situated in an area where bravery,
                                    chivalry is inherent in blood, stands true to the above couplet when
                                    one weighs it in terms of the efforts made continuously right from
                                    its establishment in 1965 to the present day. It is a
                                    prestigiousUniversity in India which has been continuously unfolding
                                    the untold chapters of Indian Freedom Struggle right from “Indian
                                    Revolution of 1857" to the “Goa MuktiSangram" (15 August, 1955)
                                    covering all the movements in general and the Gandhian Movements in
                                    particular.
                                </p>
                                <p>
                                    <strong>Recognition of KrantiDiwas (10th May)</strong>
                                </p>
                                <p>
                                    The University commemorates the martyrs of <strong>1857</strong>as{" "}
                                    <strong>freedom fighters of the First War of Independence</strong>{" "}
                                    against British, which was narrated by the British wrongly as{" "}
                                    <strong>Mutiny</strong>. The teachers and students of the University
                                    raised their voices to name May 10, 1857, the day when the
                                    revolution broke out from Meerut, as
                                    <strong>KrantiDiwas</strong> which was being named as ShahidDiwas
                                    till then. The voice was communicated to the Parliament and the
                                    Government realized the importance of the nomenclature which was
                                    only signifying a history reported by the British. Since 1989, the
                                    University has been paying homage to the less-known and unknown
                                    martyrs of the ‘<strong>KrantiDharaa</strong>’ through various
                                    events, one of them being ‘
                                    <strong>Paidal March to the Red Fort, </strong>during May 7-11,
                                    2022.{" "}
                                </p>
                                <ul start={1} type="I">
                                    <li>
                                        The District Administration in 2002 declared local holiday on 10th
                                        May to be celebrated as 'Kranti-Diwas'.
                                    </li>
                                    <li>
                                        On the behest of the University researchers, Member of the
                                        Parliament, Shri Rajendra Aggarwal, attracted attention of the
                                        House in 2015 for upgrading the Museum at the ShaheedSmarak in
                                        Meerut. In 2018, release of a financial assistance of an amount of
                                        Rs. 3.5 crore was granted to upgrade the
                                        “RajkiyaSwatantrataSangrahalaya”, Meerut for “Light &amp; Sound"
                                        show from the Ministry of Culture, Govt. of India, New Delhi.
                                    </li>
                                    <li>
                                        Our University has announced free higher education to eligible
                                        students seeking admission to various degree programmes, belonging
                                        to Village Basod, which lost all its men during 1857 revolt.{" "}
                                    </li>
                                </ul>
                                <p>
                                    <strong>Inclusion of Unsung Heroes in Syllabi</strong>
                                </p>
                                <ul>
                                    <li>
                                        The Board of Studies in History has included topics such as “Shri
                                        Gandhi Ashram” and “The Massacres in Meerut during the Quit India
                                        Movement”, in 2019 in the syllabi at both UG &amp; PG levels.
                                    </li>
                                    <li>
                                        A minor course open for all streams, has been introduced while
                                        implementing NEP-2020 entitled “
                                        <strong>
                                            Hastinapur and Kuru Kingdom through the Ages: History, Culture
                                            and Archaeology (3000 BC- 2000 AD)”,{" "}
                                        </strong>
                                        in the year 2021.
                                        <strong />
                                    </li>
                                    <li>
                                        TheUniversity has included chapters on less known or unknown brave
                                        heroes lost in oblivion, as research projects, so that the
                                        students are made aware of the unwritten history of their own
                                        people.In 2021, the Board of Studies in History introducedcourses
                                        onthe
                                        <strong>"IndianRevolution of 1857"</strong> in the syllabi of its
                                        Postgraduate curriculum as well as UG curriculum.
                                    </li>
                                </ul>
                                <p>
                                    <strong>‘Freedom Fighters' Museum’ &amp; Research</strong>
                                </p>
                                <ul>
                                    <li>
                                        The department of History has a ‘Freedom Fighters' Museum’
                                        containing life-sketches, research literature &amp; material as
                                        well as a photo gallery of unknown &amp; less known freedom
                                        fighters. A number of Ph.D. theses have been produced revealing
                                        the untold chapters of national movement.
                                    </li>
                                    <li>
                                        The local people could get authentic information about local
                                        people who had taken arms up against Colonial British Imperialism,
                                        but remained unknown. For example, ShahmalJat, Rao Kadam Singh,
                                        Dhunna Singh, Chaudhary Hardayal Singh, Chaudhary Nain Singh,
                                        LalaMatol Chand, Chaudhary Zabardast Khan, Nawab Chaudhary Ulfat
                                        Khan, Walidad Khan and many more were identified&amp; recognised.{" "}
                                    </li>
                                    <li>
                                        Several sites related to the events of 1857 have been identified
                                        and a lot of relevant material has been collected through a “dense
                                        field work” at ground level which has been incorporated in the
                                        book "
                                        <strong>
                                            <em>1857 KaViplava</em>”{" "}
                                        </strong>
                                        which wasreleased in the inaugural session of the National Seminar
                                        in the year 2008 on “
                                        <strong>Regional History &amp; Historiography of 1857</strong>"
                                        sponsored by the ICHR, New Delhi.{" "}
                                    </li>
                                    <li>
                                        More than six dozen these, dissertations and books have been
                                        produced by the research scholars and teachers of the University,
                                        highlighting the contribution of unsung Heroes.
                                    </li>
                                </ul>
                                <p>
                                    <strong>Organization of seminars/ symposia</strong>
                                </p>
                                <ul>
                                    <li>
                                        An unbroken chain of celebrating NetajiSubhash Chandra Bose Birth
                                        Anniversary on 23rd January each year right from 1989 till present
                                        day. The Literary and Cultural Council celebrates Sardar Patel's
                                        Jayanti on 31st October each year, for example Two Day National
                                        Seminar on “
                                        <strong>Two Millennia of Indian Resistance andUnification</strong>
                                        ” and “
                                        <strong>
                                            LohPurushSardarVallabh Bhai Patel : VyaktittvaevamKritittva
                                        </strong>
                                        ” was organized on 31st Oct &amp; 1st November 2018. In these
                                        events, special focus is given on the contribution of unsung
                                        heroes of Indian freedom struggle, to learn about them and to
                                        infuse nationalism in young minds.{" "}
                                    </li>
                                    <li>
                                        The University organised 34 programmes celebrating 75 years of
                                        Independence, under the ‘AzadikaAmritMahotsav’, from March 12,
                                        2021, the ‘Dandi March Day’ to August 18, 2022.{" "}
                                    </li>
                                    <li>
                                        Also, more than three dozen lectures, conferences, seminars &amp;
                                        symposia were held during the last five years exploring,
                                        exhibiting and highlighting the role of less-known and unsung
                                        heroes of the region who laid their lives in the freedom struggle
                                        of the country.{" "}
                                    </li>
                                </ul>
                                <p>
                                    The University honours the members of the families of lesser -known
                                    martyrs of Indian Freedom Struggle, who belong to the villages of
                                    the catchment area of this University on Kranti-Diwas (May 10),
                                    every year. Their stories of valour fill the youth with national
                                    pride and patriotism.
                                </p>
                                <p>
                                    The people of this area identify themselves as successors of a
                                    warrior clan. To keep alive the memories of freedom fighters, the
                                    young minds of the University are motivated to join Indian defence
                                    &amp; para-military services. For example, Jaat Regiment of Indian
                                    Army attracts our students in large numbers.
                                    {/* <a name="_GoBack" /> */}
                                </p>
                                <div className="fluid-width-video-wrapper">
                                    <object
                                        data="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/05/7.3.1 INSTITUIONAL DISTINCTIVENESS.pdf"
                                        type="application/pdf"
                                        internalinstanceid={11}
                                        style={{ height: 650, width: "100%", position: "inherit" }}
                                        id="fitvid0"
                                    >PERFORMANCE</object>
                                </div>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form7' ? 'show active' : ''}`} id="signup_form7"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>Industry Consultancy Cell</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Industry Consultancy Policy 2022</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/industry-consultancy-policy-2022.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Objectives of ICC policy</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Industry-Consultancy.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>About ICC policy</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/About-ICC-policy.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Activities</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form8' ? 'show active' : ''}`} id="signup_form8"
                            >
                                <h5>Equipment</h5>
                                <p>
                                    University equipment are maintained in departmental facilities
                                    managed by different faculty members. Departmental committees in
                                    various departments consider the purchase and recommend the annual
                                    maintenance contracts besides recommendation for purchase of
                                    consumables. Faculty member in charge in each department organises
                                    the utilisation and its availability to other departments and
                                    affiliated colleges as per requirement.
                                </p>
                                <h5>Library</h5>
                                <p>
                                    There were 1.25 Lac books, 10 thousand reference books, 30 lacs
                                    e-books, 294 journals with 40 computers in one computer lab and 2
                                    browsing centres. This year technology was upgraded and new CD's
                                    were added as a resource.
                                </p>
                                <p></p>
                                <h5>Computer and Technology</h5>
                                <p>
                                    Over 100 computers were added to various departments. Campus became
                                    Wi-Fi enabled, literacy training programmes were conducted by the
                                    IQAC and library for optimum use of e-resources.
                                </p>
                                <h5>Green initiative</h5>
                                <p>
                                    Green initiative started like exhaustive plantation of trees.
                                    Replacing traditional bulbs with tube lights and conserving water
                                    resources wherever possible.
                                </p>
                                <h5>Research</h5>
                                <p>
                                    Dedicated botanical garden and agriculture field were maintained for
                                    research purposes under auspices of relevant ministries of GOI.
                                    Animal house was constructed in this year under the guidelines of
                                    Ministry of Environment and Forest (under CPCSEA guidelines). A
                                    medicinal garden was also added. Concept of Shodh Sansthan was
                                    started.
                                </p>
                                <h5>Academic support</h5>
                                <p>
                                    The internal assessment system and the interactive programmes were
                                    highlights of this year. Students were stimulated through
                                    interaction meetings, group discussions. Projection facility was
                                    added to classes and one ICT hall was used to give an exposure of
                                    technology to students. Masters programmes were facilitated with
                                    tour grants. International collaboration with Tokyo University,
                                    Japan continued. Exchange programmes were held. Student seminar in
                                    all courses added to brainstorming and thinking capabilities.
                                    Curricula were revised to match current knowledge.
                                </p>
                                <p>
                                    University provided physical facilities such as Railway reservation
                                    counter, hostels, Bank and Post office, on the campus. A health
                                    Centre was available in campus. Park and walking track is available.
                                </p>
                                <p>
                                    A big existing AC auditorium was upgraded to better facilitate
                                    meetings. Cleaning of lab and library is done on regular basis.
                                    Maintenance and Repairing of seminar hall, class rooms, library,
                                    computer lab etc. is done as and when needed and sanctioned by
                                    university authority. All hostels have at least one badminton Court.
                                </p>
                                <h5>Equipment</h5>
                                <p>
                                    University equipment are maintained in departmental facilities
                                    managed by different faculty members. Departmental committees in
                                    various departments consider the purchase and recommend the annual
                                    maintenance contracts besides recommendation for purchase of
                                    consumables. Faculty member in charge in each department organises
                                    the utilisation and its availability to other departments and
                                    affiliated colleges as per requirement.
                                </p>
                                <h5>Library</h5>
                                <p>
                                    IT zone for accessing e-resources (e-books, e-journals and
                                    web-OPAC), e-resource centre with 50 TFT computers, Bar coded master
                                    cards, INFLIBNET/IUC facilities added.
                                </p>
                                <h5>Computer and Technology</h5>
                                <p>
                                    Computer, Internet access, training to teachers and students and
                                    other programmes for technology upgradation (Networking,
                                    e-Governance etc.)
                                </p>
                                <h5>Green initiative</h5>
                                <p>
                                    Eco friendly trash/litter collection and disposal system. Green
                                    initiative started like exhaustive plantation of trees. Replacing
                                    traditional bulbs with tube lights and conserving water resources
                                    wherever possible, continued. Enrichment of walking Arena Tapovan
                                    continued.
                                </p>
                                <h5>Research</h5>
                                <p>
                                    Animal house was registered with CPCSEA, adding a new ethical
                                    compliance chapter to research in university.
                                </p>
                                <p>
                                    New counters were opened in University administrative block for
                                    various requirements like fee submissions and degree collections.
                                </p>
                                <h5>Academic support</h5>
                                <p>
                                    While the internal assessment system and the interactive programmes
                                    continued this year, many interaction meetings, group discussions.
                                    Projection facility in classes was enriched Masters programmes were
                                    facilitated with tour grants. Student seminar in all courses added
                                    to brainstorming and thinking capabilities. Research students were
                                    given merit scholarships.
                                </p>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form9' ? 'show active' : ''}`} id="signup_form9"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Proceeding AC/ BOS</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/iqac-AC-BOS.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form10' ? 'show active' : ''}`} id="signup_form10"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Student Projects Reports</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/student_projects.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form11' ? 'show active' : ''}`} id="signup_form11"
                            >
                                 <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Academic Calendar for the Session 2024-25</td>
                                            <td><button class="btn btn-primary btn-download"><a
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/01/academic-calender-2024-25.pdf"
                                                target="_blank" rel="noreferrer">Download</a></button></td>
                                        </tr>
                                        <tr>
                                            <td>Academic Calendar 2022-23</td>
                                            <td><button class="btn btn-primary btn-download"><a
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2023-06-15_4097.pdf"
                                                target="_blank" rel="noreferrer">Download</a></button></td>
                                        </tr>
                                        <tr>
                                            <td>Academic Calendar 2023-24</td>
                                            <td><button class="btn btn-primary btn-download"><a
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/All-PDF/2023-06-14_4093.pdf"
                                                target="_blank" rel="noreferrer">Download</a></button></td>
                                        </tr>



                                        <tr>
                                            <td>Academic Calendar for the Session 2022-23</td>
                                            <td><button class="btn btn-primary btn-download"><a
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/AC-2022-23.pdf"
                                                target="_blank" rel="noreferrer">Download</a></button></td>
                                        </tr>
                                        <tr>
                                            <td>Academic Calendar for the Session 2021-22</td>
                                            <td><button class="btn btn-primary btn-download"><a
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/AC-2021-22.pdf"
                                                target="_blank" rel="noreferrer">Download</a></button></td>
                                        </tr>
                                        <tr>
                                            <td>Academic Calendar for the Session 2020-21</td>
                                            <td><button class="btn btn-primary btn-download"><a
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/AC-2020-21.pdf"
                                                target="_blank" rel="noreferrer">Download</a></button></td>
                                        </tr>
                                        <tr>
                                            <td>Academic Calendar for the Session 2019-20</td>
                                            <td><button class="btn btn-primary btn-download"><a
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/AC-2019-20.pdf"
                                                target="_blank" rel="noreferrer">Download</a></button></td>
                                        </tr>
                                        <tr>
                                            <td>Academic Calendar for the Session 2018-19</td>
                                            <td><button class="btn btn-primary btn-download"><a
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/AC-2018-19.pdf"
                                                target="_blank" rel="noreferrer">Download</a></button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form12' ? 'show active' : ''}`} id="signup_form12"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Audited Statement of Income Expenditure</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Budget-2015-21.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* <div
                                className={`tab-pane fade ${activeTab === 'signup_form13' ? 'show active' : ''}`} id="signup_form13"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Audited Statement of Income Expenditure</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a href="/career" target="_blank">
                                                        Link
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> */}

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form13' ? 'show active' : ''}`} id="signup_form13"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Student Feedback 2022-23</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/1.4_Students%20Feedback%20Responses%20(2022-23).pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Feedback</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/feedback.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Feedback Analysis</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/feedback-analysis-report-2021_22-2018.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Feedback Data for Action Taken</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/feedback-action-taken.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Feedback Analysis and Action Taken</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/feedback-analysis-action-taken.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={1}>
                                                <strong>Feedback Forms</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Student's Feedback Form</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://docs.google.com/forms/d/16nfwjb6vjLB3ei7QjmHA74ZlexpWb1hPFSbuVFJlToE/edit"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Link
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Alumni's Feedback Form</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://docs.google.com/forms/d/18snJVDDhEsO-sa0mSj59Lw6nmN3iKkOck1FJgmOHBJk/edit"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Link
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Parent's Feedback Form</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://forms.gle/uycJXy4tUgy7DfQg9"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Link
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Employer's Feedback Form</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://docs.google.com/forms/d/1sMgZY8A8D4exWBrt5Z-IGG4dZrOGSG8XCh-rNsBRbhg/edit"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Link
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Faculty's Feedback Form</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://docs.google.com/forms/d/1wdoDipyS7K3ORJy6hOAj4iAiaZ1DMtuFeYEj5U1qTMM/edit"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Link
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form14' ? 'show active' : ''}`} id="signup_form14"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title </th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Related to IQAC Webinar on Date Feb 6, 2023 at 12:00 PM</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/iqac/iqac-webinar-6feb23.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Link
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Two-day workshop "NAAC Manthan"</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/05/2023-02-03_3669.pdf"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Link
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === 'signup_form15' ? 'show active' : ''}`} id="signup_form15"
                            >
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Name </th>
                                            <th>Role</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Prof. Hare Krishna</td>
                                            <td>Coordinator</td>
                                            <td> iqac.ccsumrt@gmail.com</td>
                                            <td>0121-2603964</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;